import template from "./branding-settings.html";

const BrandingSettingsComponent = {
  template: template,
  controller: class BrandingSettingsController {
    /* @ngInject */
    constructor($rootScope, Organization, OrganizationService) {
      this.$rootScope = $rootScope;
      this.Organization = Organization;
      this.OrganizationService = OrganizationService;
    }

    $onInit() {
      this.editableOrganization = angular.copy(this.$rootScope.organization);
    }

    getStyle(element, marginLeft, fontSize) {
      return {
        "margin-left": `${marginLeft}px`,
        "color": this.editableOrganization.branding[element].color,
        "font-family": this.editableOrganization.branding[element].font.family,
        "font-size": `${fontSize}px`,
      };
    }

    async changeColor(color, element) {
      this.editableOrganization.branding[element].color = color;
      await this.OrganizationService.updateOrganization(this.editableOrganization);
    }

    async changeFont(font, element) {
      this.editableOrganization.branding[element].font = font;
      await this.OrganizationService.updateOrganization(this.editableOrganization);
    }
  },
};

export default BrandingSettingsComponent;
